<template>
  <div class="inquire" v-cloak>
    <div class="sol-bg">
      <app-header></app-header>
      <div class="sol-banner">
        <div class="sol-title-box">
          <p class="sol-title"><span>{{ $t('xdata.Nav_vpnjjfa')}}</span></p>
        </div>
      </div>
    </div>
    <p class="sol-sub animated flipInX">{{ $t('xdata.Vpn_xgjj')}}</p>
    <div class="sol-content">
      <div class="sol-content-box">
        <p class="sol-content-title">{{ $t('xdata.Vpn_xgjjt1')}}</p>
        <p class="sol-content-sub">{{ $t('xdata.Vpn_xgjjt2')}}
          </p>
        <div class="u-flex u-flex-between u-flex-wrap sol-content-list">
          <sol-item type="left" :title="$t('xdata.Vpn_xgjjt3') "
            :content="$t('xdata.Vpn_xgjjt4')"></sol-item>
          <sol-item type="right" :title="$t('xdata.Vpn_xgjjt5') "
          :content="$t('xdata.Vpn_xgjjt6')"></sol-item>
        </div>
        <div class="sol-img-box">
          <p>{{ $t('xdata.Vpn_xgjjt7')}}</p>
          <img src="@/assets/img/sdwan/pt.png">
        </div>
        <div class="u-flex u-flex-between u-flex-wrap sol-content-list">
          <sol-item type="left" :title="$t('xdata.Vpn_xgjjt8')" :content="$t('xdata.Vpn_xgjjt10')"></sol-item>
          <sol-item type="right" :title="$t('xdata.Vpn_xgjjt9')" :content="$t('xdata.Vpn_xgjjt11')"></sol-item>
        </div>
        <div class="sol-img-box">
          <p>{{ $t('xdata.Vpn_xgjjt12')}}</p>
          <img src="@/assets/img/sdwan/pt2.png" v-if="lang == 'zh-CN' "/>
          <img src="@/assets/img/sdwan/pt2_en.png" v-else>
        </div>
        <div class="u-flex u-flex-between u-flex-wrap sol-content-list">
          <sol-item type="left" :title="$t('xdata.Vpn_xgjjt13')" :content="$t('xdata.Vpn_xgjjt14')"></sol-item>
          <sol-item type="right" :title="$t('xdata.Vpn_xgjjt15')" :content="$t('xdata.Vpn_xgjjt16')"></sol-item>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>

import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";
import SolItem from "@/components/solItem";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "data-item": DataItem,
    "sol-item": SolItem,
  },
  name: "service",
  data() {
    return {
      lang:''
    };
  },
  created(){
    this.lang = localStorage.getItem('lang') 
  },
  mounted() {
  },
  methods: {

  }
};
</script>
<style scoped>
.sol-bg {
  width: 100%;
  background: url('../../assets/img/solution_bg2.jpg') no-repeat fixed top center / 100% auto;
}

.sol-banner {
  height: 240px;
  background: rgba(0, 0, 0, 0.3);
}

.sol-title-box {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}

.sol-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
}

.sol-content {
  background: #f4f4f4;
}

.sol-content-box {
  width: 1200px;
  margin: 0 auto;
}

.sol-content-title {
  font-size: 28px;
  text-align: center;
  padding: 50px 0 0;
}

.sol-content-sub {
  text-align: center;
  font-size: 14px;
  color: #777777;
}

.sol-content-text {
  color: #fff;
}

.sol-content-list {
  padding-top: 50px;
}

.sol-img-box p {
  font-size: 24px;
  margin-bottom: 24px;
  font-weight: bold;
  text-align: center;
}

.sol-img-box img {
  width: 70%;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/solution/vpnSolution.vue